module.exports = __webpack_public_path__ + "intuit-mockup.2CBiSRKl.png";